// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__p26GL","copyright":"Footer_copyright__dVzo+"};